module.exports = __webpack_public_path__ + "media/images/icon__edit--rb-red@3x-ca7cc706c0f23a204730e36bd2c60b7b.png";